import * as React from 'react';
import isEqual from 'lodash/isEqual';
import { useLocation, useMatches } from 'react-router-dom';
import { getTrackingProps } from '../helpers';
import { sendPage } from '../sendPage';
export function TrackingProvider({
  children
}) {
  const location = useLocation();
  const matches = useMatches();
  const prevTracking = React.useRef();
  React.useEffect(() => {
    const tracking = getTrackingProps(matches);
    if (tracking && !tracking.noTrack && !isEqual(tracking, prevTracking.current)) {
      const {
        prefix,
        noTrack,
        ...trackingPageProps
      } = tracking;
      sendPage(trackingPageProps);
    }
    prevTracking.current = tracking;
  }, [location, matches]);
  return children;
}